<template>
    <ul class="codes">
        <li :class="{ active: showCodeIndex == 0 }" @click.stop="showCodeIndex = 0">
            <img src="@/assets/imgs/icon14.png" alt="">
            <img :src="setting.officialCode" alt="" class="code" v-if="showCodeIndex == 0">
        </li>
        <li :class="{ active: showCodeIndex == 1 }" @click.stop="showCodeIndex = 1">
            <img src="@/assets/imgs/icon13.png" alt="">
            <img :src="setting.channelCode" alt="" class="code" v-if="showCodeIndex == 1">
        </li>
        <li :class="{ active: showCodeIndex == 2 }" @click.stop="showCodeIndex = 2">
            <img src="@/assets/imgs/icon10.png" alt="">
            <img :src="setting.wxCode" alt="" class="code" v-if="showCodeIndex == 2">
        </li>
        <li :class="{ active: showCodeIndex == 3 }" @click.stop="showCodeIndex = 3">
            <img src="@/assets/imgs/icon12.png" alt="">
            <img :src="setting.douyinCode" alt="" class="code" v-if="showCodeIndex == 3">
        </li>
    </ul>
</template>
<script setup>
import { computed, ref, onMounted } from 'vue'
import { useStore } from 'vuex'
import * as api from '@/request/front'
const store = useStore()
const showCodeIndex = ref(-1)
const setting = computed(() => store.state.front.websitConfig)
onMounted(() => {
    document.addEventListener('click', () => {
        showCodeIndex.value = -1
    })
})
</script>
<style scoped lang="scss">
.codes {
    padding: 20rem;
    margin-top: 50rem;
    display: flex;
    justify-content: space-around;

    li {
        width: 44rem;
        height: 44rem;
        background-color: #A7A7A7;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 22rem;

        img {
            width: 27rem;
            height: auto;
        }

        .code {
            position: absolute;
            bottom: 50rem;
            left: -25rem;
            width: 90rem;
            height: 90rem;
        }
    }

    .active {
        background-color: #000;
    }
}
</style>